import { API } from '@/api';

export const classes = {
  placeholder:
    'w-full text-left px-[13px] py-[10px] text-[12.5px] text-taupe-1 dark:text-mauve-3 cursor-text hover:bg-black/[0.02] dark:hover:bg-white/[0.03] ease-in-out duration-100',
  field: 'm-3',
};

export const styles = {
  placeholder: {
    transitionProperty: 'color, background-color, padding',
  },
};

export function createComment(noteId: number, message: string) {
  return API.Notes.createNewNoteComment({ noteId, message });
}
